import Link from 'next/link'

import { useTranslations } from 'next-intl'

import { Languages, ProductCardType } from '@/constants'
import { useAuth, useStore } from '@/containers'
import { getTranslate } from '@/utils/api-interceptors'


interface PriceType {
  type?: string
  className?: string
  link?: string
  priceAtWarehouse?: boolean
  hasGift?: boolean
  hasDeal?: boolean
  originPrice: number
  finalPrice: number
  stockStatus?: string
  priceDescription?: Record<string, string>
}

export const Price = ({
  type,
  originPrice,
  finalPrice,
  hasGift,
  hasDeal,
  priceAtWarehouse,
  className = '',
  link = '',
  stockStatus = '',
  priceDescription,
}: PriceType) => {
  const { token } = useAuth()
  const { selectedLang } = useStore()
  const t = useTranslations('ProductDetail')

  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'VND'
      default:
        return 'VND'
    }
  }

  const percent = Math.ceil(100 - (finalPrice / originPrice) * 100)

  
return (
    <div className={`${className} price-wrapper w-full`}>
      {type === ProductCardType.PRODUCT_DETAIL && stockStatus !== 'OOS' && (
        <span className='mb-0.5 block text-lg font-bold text-dark-400'>
          {priceDescription ? (
            getTranslate(priceDescription)
          ) : (
            <>
              {hasDeal
                ? 'Giá DEAL độc quyền'
                : priceAtWarehouse
                ? t('warehousePrice')
                : hasGift
                ? 'Giá online rẻ hơn'
                : t('priceWithShip')}
            </>
          )}
          :
        </span>
      )}
      {stockStatus === 'OOS' && (
        <span className='mb-0.5 block text-lg font-bold text-dark-400'>
          {t('priceWithShip')}
        </span>
      )}
      <div className='flex-start flex items-center gap-x-1'>
        <p
          className={`${
            type === 'product-detail' ? 'text-lg' : 'text-sm'
          } leading-normal text-black-100 line-through`}
        >
          {originPrice &&
            originPrice
              .toLocaleString(Languages.VN, {
                style: 'currency',
                currency: currency(selectedLang as string),
              })
              .replace(/\s₫/g, 'đ')}
        </p>
        {percent > 0 && (
          <span className='discount flex w-max items-center rounded bg-pink-300/20 px-[3px] text-sm font-semibold leading-5 text-primary-base'>
            <span className='value'>{'-' + percent}</span>
            <span className='unit'>%</span>
          </span>
        )}
      </div>
      <div className='sale-price flex items-center justify-between'>
        {token ? (
          <p
            className={`${
              type === 'product-detail'
                ? 'text-3xl font-black leading-10 text-primary-base'
                : 'text-xl font-bold leading-6 text-primary-base'
            }`}
          >
            {finalPrice &&
              finalPrice
                .toLocaleString(Languages.VN, {
                  style: 'currency',
                  currency: currency(selectedLang as string),
                })
                .replace(/\s₫/g, 'đ')}
          </p>
        ) : (
          <Link href={link} className='flex items-center gap-x-1 text-mainBody'>
            <p
              className={`${
                type === 'product-detail'
                  ? 'text-3xl font-black leading-10 text-primary-base'
                  : 'text-xl font-bold leading-6 text-primary-base'
              }`}
            >
              {finalPrice &&
                finalPrice
                  .toLocaleString(Languages.VN, {
                    style: 'currency',
                    currency: currency(selectedLang as string),
                  })
                  .replace(/\s₫/g, 'đ')}
            </p>
          </Link>
        )}
      </div>
    </div>
  )
}

export default Price
